import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const projectRoutes: RouteRecordRaw[] = [
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@/modules/projects/views/ProjectListView.vue'),
    meta: {
      permission: PERMISSIONS.PROJECT.LIST,
    },
  },
]
